module.exports = __webpack_public_path__ + "static/media/klinicq-pharmacy-management-software.14a20a15.webp";